import { ConfidentialityLevel } from '@dreryk/egabinet-medical-data-confidentiality-published-language-api';

import { BindingCreator } from '@dreryk/react-common';
import { RadioGroup, RadioGroupItem } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../../translations';

const t = patientMedicalInformationTranslationKeys.shared.fields.confidentialityLevel;

const CONFIDENTIALITY_LEVEL_FIELD_NAME = 'confidentialityLevel';

const CONFIDENTIALITY_LEVEL_RADIO_ITEMS: RadioGroupItem<ConfidentialityLevel>[] = [
   { id: 'NORMAL', label: t.confidentialityLevelMap.NORMAL },
   { id: 'CONFIDENTIAL', label: t.confidentialityLevelMap.CONFIDENTIAL },
];

export type ConfidentialityLevelFormBeanPart = {
   [CONFIDENTIALITY_LEVEL_FIELD_NAME]: ConfidentialityLevel;
};

type MedicalInformationConfidentialityLevelFieldProps = {
   readonly register: BindingCreator<ConfidentialityLevelFormBeanPart>;
};

export const MedicalInformationConfidentialityLevelField = (
   props: MedicalInformationConfidentialityLevelFieldProps
): JSX.Element => {
   return (
      <RadioGroup<ConfidentialityLevel>
         testId={'confidentialityLevel'}
         label={t.label}
         items={CONFIDENTIALITY_LEVEL_RADIO_ITEMS}
         horizontal
         controller={props.register(CONFIDENTIALITY_LEVEL_FIELD_NAME, { required: true })}
      />
   );
};
